module.exports = __webpack_public_path__ + "f8fae6754e0df9ab0a60d687147cff36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/ir_6.jpg
// module id = 1717
// module chunks = 5